import React from 'react';
import { Link } from 'react-router-dom';

const limitTitle = (title, limit = 18) => {
    const newTitle = [];
    if(title.length > limit) {
        title.split(" ").reduce((acc, curr) => {
            if(acc + curr.length <= limit) {
                newTitle.push(curr)
            }
            return acc + curr.length;
        }, 0);
        return `${newTitle.join(" ")}...`;
    }
    return title;
}

const Recipes = props => (
    <div className="conainer mx-auto wrapper" style={{width: "90%", marginTop: "4.5rem"}}>
        <div className="row">
            { props.recipes && props.recipes.map(recipe => {
                return (
                    <div className="col-md-6 col-lg-4 mb-4" key={recipe.recipe_id}>
                        <div className="card">
                            <img src={recipe.image_url} className="card-img-top" alt={recipe.title} style={{height: "300px"}} />
                            <div className="card-body">
                                <h5 className="card-title">{limitTitle(recipe.title)}</h5>
                                <p className="card-text">Author: <span>{recipe.publisher}</span></p>
                                <Link to={{pathname: `/recipe/${recipe.recipe_id}`, state: {recipe: recipe.title}}} className="btn btn-outline-danger shadow-none">View Recipe</Link>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
);

 
export default Recipes;